import { Box, Expandable } from '@warp-ds/react';
import { ImagePanel } from 'shared/components/ImagePanel';
import { PriceDetail } from '@/components/priceOverview/components/PriceDetail';
import { PriceOverview } from '@/components/priceOverview/PriceOverview';
import type { PrivateItemPrice } from '@/domain';
import { formatBookingDateNumeric } from '@/utils/formatting';
import styles from '../CreateRentalRequestPage.module.css';

type RequestSummaryPanelProps = {
    images: { src: string }[] | undefined;
    startDate: Date;
    endDate: Date;
    guests: string | string[] | undefined;
    privateItemPrice: PrivateItemPrice | undefined;
    priceDetailsExpanded: boolean;
    setPriceDetailsExpanded: (value: boolean) => void;
};

export const RequestSummaryPanel = ({
    images,
    startDate,
    endDate,
    guests,
    privateItemPrice,
    priceDetailsExpanded,
    setPriceDetailsExpanded,
}: RequestSummaryPanelProps) => (
    <ImagePanel
        img={{
            src: images?.[0]?.src || '',
            alt: 'Hovedbilde fra annonsen',
        }}
        hideImageOnSmallScreens>
        <section className="flex flex-col gap-8">
            <h2 className="text-14">Din forespørsel</h2>
            <dl className="m-0">
                <PriceDetail title="Leieperiode" value={`${formatBookingDateNumeric(startDate)} - ${formatBookingDateNumeric(endDate)}`} />
                <PriceDetail title="Antall reisende" value={`${guests} reisende`} />
                {privateItemPrice?.total && <PriceDetail title="Pris for oppholdet" money={privateItemPrice.total} />}
            </dl>
        </section>
        <Box info className="flex flex-row items-center gap-8 text-12 p-8 m-0">
            <w-icon name="Info" size="small" aria-hidden />
            <p>Du betaler ingenting før du selv bekrefter bestillingen</p>
        </Box>
        <Expandable
            title={
                <div className="flex flex-row items-center justify-between gap-8 w-full s-text-link text-14">
                    <span>Vis prisdetaljer</span>
                    <w-icon
                        name="ChevronDown"
                        size="small"
                        className={`s-text-link ${styles.chevron} ${priceDetailsExpanded ? styles.chevronExpanded : ''}`}
                        aria-hidden
                    />
                </div>
            }
            animated
            chevron={false}
            expanded={priceDetailsExpanded}
            onChange={setPriceDetailsExpanded}
            buttonClass="w-full s-text-link font-bold"
            contentClass="pt-4">
            <PriceOverview
                startDate={startDate}
                endDate={endDate}
                showConfirmedCleaning={true}
                showPriceHeading={false}
                privateItemPrice={privateItemPrice}
            />
        </Expandable>
    </ImagePanel>
);
